import { createMuiTheme } from "@material-ui/core/styles";
import * as colors from "@material-ui/core/colors";

/* Colors - names from htmlcsscolor.com,
   Variations from https://material.io/resources/color/#!/?view.left=0&view.right=0 and
   https://www.w3schools.com/colors/colors_picker.asp */

/* Colors - names from htmlcsscolor.com */
// const HL_CobaltColor = "#0D47A1"; // header rows
// const HL_RoyalBlueColor = "#5471D2"; // light color
// const HL_HawkesBlueColor = "#CFDBED"; // 20% tint on cobalt; used for bands

/* From Center for Humanitarian Health website. */
const HL_PictonBlue = "#418FDE";
const HL_Sapphire = "#092C74";
export const HL_DarkPurple = "#8E3D80";
export const HL_MountainMeadow = "#1AAB8C";
const HL_Tranquil = "#D3F8F0";
const HL_BondiBlue = "#008CBA"; // secondary labels
const HL_JordyBlue = "#67A5E4"; // dividers on white background
const HL_LightYellow = "#FFFFE6";
const HL_CuriousBlue = "#2F8CC0";

export const HL_PrimaryColor = HL_PictonBlue;
export const HL_SecondaryColor = HL_Sapphire;
export const HL_BandColor = HL_Tranquil;

/* Colors to be used by all components (whether they are Material UI or not. */
export const bandColor = colors.blue[50];
export const lightGrayColor = colors.grey[100];
export const orangeColor = "#F7991E"; //#1293AC";
export const gray29Color = "#4A4A4A";
export const gray15Color = "#262626";
export const darkGrayColor = "#A9A9A9";
export const whiteColor = "#FFFFFF";
export const blackColor = "#000000";
export const hyperLinkColor = "#337AB7";
export const red = "#FF0000";

/* Color for home page */
export const greenBoxColor = "#91944f";

/* World map estimates colors. */
export const noDataEstColor = "#F7F7F7";
export const estColor1 = "#FEE9C2";
export const estColor2 = "#FDDBA4";
export const estColor3 = "#F8B56D";
export const estColor4 = "#F38E2E";
export const estColor5 = "#E7112B";
export const estColor6 = "#9A0316";

export const orangeSelectedColor = "#FFD666";

export const palatinatePurpleColor = "#702C5A"; // primary
export const strikemasterPurpleColor = "#A05887"; // primary - lighter
export const blackberryPurpleColor = "#420031"; // primary - dark
export const hippieBlueColor = "#3E8AA0"; // secondary

export const blueSelectedColor = "#0D0B80";

export const estColors = [estColor1, estColor2, estColor3, estColor4, estColor5, estColor6];

/* Component color constants */
export const HL_ExampleDivColor = HL_SecondaryColor; // HL_PrimaryColor;
export const HL_LabColor = HL_BondiBlue;
export const HL_BtnBackgroundColor = HL_PrimaryColor; //HL_SecondaryColor;//;
export const HL_DividerColor = HL_JordyBlue;
export const HL_FormYellowColor = HL_LightYellow;
export const HL_LinkBlue = HL_CuriousBlue;

export const HL_JHU_LogoMinWidth = 255; // width of Hopkins icons must be 190 pixels from the most left to most right visible parts of image
export const HL_JHU_LogoMinHeight = 109; // minimum height gotten from using object inspector on logo when width is 255

export const fontFamily = ["lato, sans-serif"]; //["Gentona Book", "Open Sans Condensed", "sans-serif"];

export const dividerStyle = {
    backgroundColor: HL_DividerColor,
};

export const pageHeadingWithBannerStyle = {
    marginTop: 20,
};

export const pageHeadingFontStyle = {
    color: blackColor,
    fontFamily: fontFamily,
    fontSize: 30,
    fontWeight: 800,
    lineHeight: 1.15,
    letterSpacing: "0.01rem",
    margin: 0,
    marginBottom: 15,
    marginTop: 30,
    //textDecoration : "underline",
};

export const stepSubTextHeadingFontStyle = {
    fontWeight: 400,
};

export const exampleDivStyle = {
    backgroundColor: HL_ExampleDivColor, //HL_PrimaryColor
    border: "solid",
    borderColor: HL_ExampleDivColor, //HL_PrimaryColor,
    borderWidth: 2,
    color: whiteColor,
    marginRight: 20,
    marginTop: 20,
    paddingLeft: 10,
    paddingRight: 10,
};

export const simpleBorderStyle = {
    border: "solid",
    borderCollapse: "collapse",
    borderColor: blackColor,
    borderWidth: 1,
};

export const HL_FooterPosition = 750;
export const HL_FooterOffset = 80;

export const appTitleFontStyle = {
    fontFamily: fontFamily, //["Gentona Semi Bold", 'Open Sans Condensed', "sans-serif"],
};

export const menuItemFontStyle = {
    fontFamily: fontFamily, //["Gentona Book", 'Open Sans Condensed', "sans-serif"], // was Gentona Thin
    //fontWeight    : 700,
    letterSpacing: "0.05em",
};

export const labelFontStyle = {
    fontFamily: fontFamily, //["Gentona Semi Bold", 'Open Sans Condensed', "sans-serif"],
    fontWeight: 700,
    letterSpacing: "0.05em",
    lineHeight: 1.15,
};

export const textFontStyle = {
    fontFamily: fontFamily, //["Gentona Book", 'Open Sans Condensed', "sans-serif"],
    fontWeight: 400,
    lineHeight: 1.4,
};

export const fontStyle = {
    fontFamily: fontFamily,
    letterSpacing: "0.05em",
    fontWeight: 700,
};

export const leftIndent = 20;
export const topIndent = 20;
export const ctrlSpacing = 10;

export const navBtnWidth = 120;

export const labelStyle = {
    color: HL_LabColor,
    //fontFamily : fontFamily,
    ...labelFontStyle,
    fontSize: 18,
    //fontWeight : "bold",
};

/* Centers a component horizontally. */
export const hCenteredStyle = {
    display: "flex",
    justifyContent: "center",
};

/* Aligns a component to the right. */
export const hRightStyle = {
    display: "flex",
    justifyContent: "flex-end",
};

/* Centers a component vertically. */
export const vCenteredStyle = {
    display: "flex",
    alignItems: "center",
};

/* Places components next to each other in a row. */
export const sideBySideStyle = {
    display: "flex",
    flexDirection: "row",
};

export const bulletListIndent2 = 40;

/* These are for styling non-Material UI components using the same colors that the
   Material UI components use. Thus, styles should come from Theme.js */

export const styles = {
    listItemLab: {
        fontSize: "16px",
        color: gray29Color,
        fontWeight: 500,
        fontStyle: "normal",
    },
    listItemSelectedLab: {
        fontSize: "16px",
        color: hippieBlueColor,
        fontWeight: "bold",
        fontStyle: "normal",
    },
    listItemDisabledLab: {
        fontSize: "16px",
        color: darkGrayColor,
        fontWeight: 500,
        fontStyle: "normal",
    },
    headerLab: {
        color: gray29Color,
        height: 35, // needed to fit selectFacilityDiv on same line
        ...fontStyle,
        fontSize: "28px",
        fontStyle: "normal",
        fontWeight: "bold",
        padding: "1% 0", // vertically center page header
    },
    questionLab: {
        color: gray29Color,
        marginBottom: 10,

        fontStyle: "normal",
        ...fontStyle,
        fontWeight: 500,
    },
    buttonLab: {
        color: gray29Color,
        fontSize: "16px",
        fontStyle: "normal",
        ...fontStyle,
        fontWeight: 500,
    },
    buttonSelectedLab: {
        color: orangeColor,
        fontSize: "16px",
        fontStyle: "normal",
        ...fontStyle,
        fontWeight: "bold",
    },
    buttonDisabledLab: {
        color: darkGrayColor,
        fontSize: "16px",
        fontStyle: "normal",
        ...fontStyle,
        fontWeight: 500,
    },
    editBeforeButtonStyle: {
        marginBottom: 0,
    },
    editBeforeLabStyle: {
        marginBottom: 20,
    },
    comboBoxCaptionStyle: {
        color: orangeColor,
        fontSize: "12px",
        ...fontStyle,
        marginLeft: "20px",
    },
    comboBoxBeforeLabStyle: {
        marginBottom: 20,
    },
    accordionStyle: {
        width: "650px",
    },
    iconBeforeButtonStyle: {
        marginBottom: 20,
    },
    sheetStyle: {
        height: "225px",
        width: "500px",
    },
    filterBox: {
        marginBottom: 5,
        marginTop: 5,
    },
    filterGroupLabStyle: {
        marginLeft: 0,
        // height: 40,
        marginBottom: 5,
        marginTop: 0,
        fontSize: 16,
    },
    filterGroupAboveComboLabStyle: {
        fontSize: 12,
    },
    filterGroupLongLabStyle: {
        marginLeft: 15,
        width: 600,
    },
};

const muiTheme = createMuiTheme({
    typography: {
        fontStretch: "normal",
        ...fontStyle,
        //useNextVariants: true,
    },
    palette: {
        primary: {
            main: HL_PrimaryColor,
            contrastText: whiteColor,
        },
        secondary: {
            main: HL_SecondaryColor,
            contrastText: whiteColor,
        },
    },
    appBar: {
        backgroundColor: gray15Color, //whiteColor,
    },
    standardSideBar: {
        backgroundColor: orangeColor, //whiteColor,//'#05225d',
        //border: 'none'
    },
    toolsSideBar: {
        backgroundColor: whiteColor,
        border: "none",
    },
    editor: {
        bandColor: "#f0f6df",
        fixedRowColor: "#9cc025",
        highlightColor: "#fff1a6",
        cellPadding: "3",
    },
    bandColor: {
        backgroundColor: bandColor, //'e8ffdd' //'#f0f6df'
    },
    commandBar: {
        backgroundColor: colors.blue[100], //'hotpink',
        color: blackColor,
    },
    errorTitle: {
        margin: "0 0 10px 0",
        fontWeight: "bold",
    },
    errorParagraph: {
        margin: "0 0 10px 0",
    },
    errorBox: {
        background: "#EF9A9A",
        borderRadius: "5px",
        padding: "10px",
        marginBottom: "20px",
    },
    paperAnchorDockedLeft: {
        borderRight: "none",
    },
});

export default muiTheme;
